import React from 'react'
import { useContext } from 'react'
import AppContext from '../context/appContext'
const AdminHome = () => {
    const appContext = useContext(AppContext)
    const {allUsers} = appContext
    const totalAmount = allUsers.reduce((sum, tx) => sum + Number(tx.amount), 0);
    const totalWithdraws = allUsers.reduce((sum, tx) => sum + Number(tx.withdraws.length), 0);
    const totalWithdrawAmount = allUsers.reduce((sum, tx) => sum + Number(tx.withdraws.reduce((sum,thx)=>sum+Number(thx.amount) ,0)), 0);
    
    const totalPendingWithdraws = allUsers.reduce((count, user) => {
        return count + user.withdraws.filter(withdraw => withdraw.status === "pending").length;
    }, 0);
    const totalCompletedWithdraws = allUsers.reduce((count, user) => {
        return count + user.withdraws.filter(withdraw => withdraw.status === "Completed").length;
    }, 0);

    
    const totalPendingWithdrawsAmount = allUsers.reduce((count, user) => {
        return count + user.withdraws.filter(withdraw => withdraw.status === "pending").reduce((sum,tx)=>sum+Number(tx.amount),0);
    }, 0);
    
    const totalCompletedWithdrawsAmount = allUsers.reduce((count, user) => {
        return count + user.withdraws.filter(withdraw => withdraw.status === "Completed").reduce((sum,tx)=>sum+Number(tx.amount),0);
    }, 0);

    console.log(totalPendingWithdrawsAmount);
    

    console.log(totalPendingWithdraws);
    

    console.log(totalWithdrawAmount);
    console.log(totalWithdraws);
    console.log(totalAmount);
    
    return (
   
            <div className="px-md-5">
                <h1 className="text-light">Admin Dashboard</h1>
                <div className="container-fluid pt-3 pb-5">
                    <div className="px-md-5">

                        <div data-aos="fade-up" data-aos-duration="1000" className="row">
                            <div className="col-sm-6 col-lg-4 col-12 my-2">
                                <div class="card h-100 rounded-4 overflow-hidden" style={{ borderColor: "#fff", backgroundColor: "#23153c" }}>
                                    {/* <img src="..." class="card-img-top" alt="..."/> */}
                                    <div className='px-5 pb-3 pt-4' style={{ borderRadius: '100%' }}>
                                        <p className='display-6 h1 text-light' style={{ fontWeight: "bold" }}>{allUsers.length}</p>
                                    </div>
                                    <div class="card-body d-flex flex-column">
                                        <h2 class="card-title text-light">Total Users                                   </h2>
                                        <p class="card-text text-light">Fully audited smart contract with zero human intervention</p>

                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-6 col-lg-4 col-12 my-2">
                                <div class="card h-100 rounded-4 overflow-hidden" style={{ borderColor: "#fff", backgroundColor: "#23153c" }}>
                                    {/* <img src="..." class="card-img-top" alt="..."/> */}
                                    <div className='px-5 pb-3 pt-4' style={{ borderRadius: '100%' }}>
                                        <p className='display-6 h1 text-light' style={{ fontWeight: "bold" }}>{totalAmount}$</p>
                                    </div>
                                    <div class="card-body d-flex flex-column">
                                        <h2 class="card-title text-light">Total Revenue                                   </h2>
                                        <p class="card-text text-light">Fully audited smart contract with zero human intervention</p>

                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-6 col-lg-4 col-12 my-2">
                                <div class="card h-100 rounded-4 overflow-hidden" style={{ borderColor: "#fff", backgroundColor: "#23153c" }}>
                                    {/* <img src="..." class="card-img-top" alt="..."/> */}
                                    <div className='px-5 pb-3 pt-4' style={{ borderRadius: '100%' }}>
                                        <p className='display-6 h1 text-light' style={{ fontWeight: "bold" }}>{totalWithdraws}</p>
                                    </div>
                                    <div class="card-body d-flex flex-column">
                                        <h2 class="card-title text-light">Total Withdraws                                  </h2>
                                        <p class="card-text text-light">Fully audited smart contract with zero human intervention</p>

                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-6 col-lg-4 col-12 my-2">
                                <div class="card h-100 rounded-4 overflow-hidden" style={{ borderColor: "#fff", backgroundColor: "#23153c" }}>
                                    {/* <img src="..." class="card-img-top" alt="..."/> */}
                                    <div className='px-5 pb-3 pt-4' style={{ borderRadius: '100%' }}>
                                        <p className='display-6 h1 text-light' style={{ fontWeight: "bold" }}>{totalWithdrawAmount}$</p>
                                    </div>
                                    <div class="card-body d-flex flex-column">
                                        <h2 class="card-title text-light">Withdraws Amount                                  </h2>
                                        <p class="card-text text-light">Fully audited smart contract with zero human intervention</p>

                                    </div>
                                </div>
                            </div>
                            
                            <div className="col-sm-6 col-lg-4 col-12 my-2">
                                <div class="card h-100 rounded-4 overflow-hidden" style={{ borderColor: "#fff", backgroundColor: "#23153c" }}>
                                    {/* <img src="..." class="card-img-top" alt="..."/> */}
                                    <div className='px-5 pb-3 pt-4' style={{ borderRadius: '100%' }}>
                                        <p className='display-6 h1 text-light' style={{ fontWeight: "bold" }}>{totalPendingWithdraws}</p>
                                    </div>
                                    <div class="card-body d-flex flex-column">
                                        <h2 class="card-title text-light">Total Pending Withdraws                                  </h2>
                                        <p class="card-text text-light">Fully audited smart contract with zero human intervention</p>

                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-6 col-lg-4 col-12 my-2">
                                <div class="card h-100 rounded-4 overflow-hidden" style={{ borderColor: "#fff", backgroundColor: "#23153c" }}>
                                    {/* <img src="..." class="card-img-top" alt="..."/> */}
                                    <div className='px-5 pb-3 pt-4' style={{ borderRadius: '100%' }}>
                                        <p className='display-6 h1 text-light' style={{ fontWeight: "bold" }}>{totalPendingWithdrawsAmount}$</p>
                                    </div>
                                    <div class="card-body d-flex flex-column">
                                        <h2 class="card-title text-light">Total Pending Withdraws Amount                                </h2>
                                        <p class="card-text text-light">Fully audited smart contract with zero human intervention</p>

                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-6 col-lg-4 col-12 my-2">
                                <div class="card h-100 rounded-4 overflow-hidden" style={{ borderColor: "#fff", backgroundColor: "#23153c" }}>
                                    {/* <img src="..." class="card-img-top" alt="..."/> */}
                                    <div className='px-5 pb-3 pt-4' style={{ borderRadius: '100%' }}>
                                        <p className='display-6 h1 text-light' style={{ fontWeight: "bold" }}>{totalCompletedWithdraws}</p>
                                    </div>
                                    <div class="card-body d-flex flex-column">
                                        <h2 class="card-title text-light">Total Completed Withdraws                                </h2>
                                        <p class="card-text text-light">Fully audited smart contract with zero human intervention</p>

                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-6 col-lg-4 col-12 my-2">
                                <div class="card h-100 rounded-4 overflow-hidden" style={{ borderColor: "#fff", backgroundColor: "#23153c" }}>
                                    {/* <img src="..." class="card-img-top" alt="..."/> */}
                                    <div className='px-5 pb-3 pt-4' style={{ borderRadius: '100%' }}>
                                        <p className='display-6 h1 text-light' style={{ fontWeight: "bold" }}>{totalCompletedWithdrawsAmount}$</p>
                                    </div>
                                    <div class="card-body d-flex flex-column">
                                        <h2 class="card-title text-light">Total Completed Withdraws Amount                               </h2>
                                        <p class="card-text text-light">Fully audited smart contract with zero human intervention</p>

                                    </div>
                                </div>
                            </div>
                            



                        </div>
                    </div>
                </div>
            </div>
      
    )
}

export default AdminHome